<template>
  <div>
    <div v-if="!!section">
      <div class="text-h6 text-center mt-2 mb-2">場次資訊</div>
      <div>
        <v-text-field
          label="日期"
          :value="section.日期"
          dense
          outlined
          disabled
        ></v-text-field>
      </div>
      <div>
        <v-text-field
          label="地點"
          :value="section.地點"
          dense
          outlined
          disabled
        ></v-text-field>
      </div>

      <div class="text-h6 text-center mb-2">篩檢站點</div>
      <div>
        <v-select
          v-model="type"
          :items="stations"
          label="選擇站點"
          outlined
          dense
        ></v-select>
      </div>
      <v-btn block x-large color="#0f4c81" dark @click="selectStation">
        確認
      </v-btn>
    </div>
    <div v-else>
      <v-alert type="error" class="fixed-alert">
        場次資訊錯誤，請重新掃描場次 QR code
      </v-alert>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { 站點 } from "@/libs/const";
export default {
  name: "station",
  data: () => ({
    id: null,
  }),
  computed: {
    ...mapFields(["station.section", "station.type"]),
    stations() {
      return Object.keys(站點);
    },
  },
  async created() {
    let id = this.$route.params.id;
    if (id && /^[0-9a-fA-F]{24}$/.test(id)) {
      this.section = (await this.axios.get(`/section/${id}`)).data;
      this.$forceUpdate();
    }
  },
  methods: {
    selectStation() {
      if (this.type) {
        this.$router.push("/station/scan");
      } else {
        this.$toast.error("請選擇站點");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.fixed-alert {
  position: fixed;
  top: 50%;
  width: 96%;
  left: 2%;
}
</style>
